export enum Role {
    ADMIN = "ADMIN",
    COMISSARY = "COMISSARY",
    DRIVER = "DRIVER",
}

export const RoleDescription = {
    ADMIN: "Administrador",
    COMISSARY: "Comissário",
    DRIVER: "Piloto",
};
